import { render, staticRenderFns } from "./EditDialog.vue?vue&type=template&id=54b42eb7&scoped=true"
import script from "./EditDialog.vue?vue&type=script&lang=js"
export * from "./EditDialog.vue?vue&type=script&lang=js"
import style0 from "./EditDialog.vue?vue&type=style&index=0&id=54b42eb7&prod&scoped=true&lang=css"
import style1 from "./EditDialog.vue?vue&type=style&index=1&id=54b42eb7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b42eb7",
  null
  
)

export default component.exports